import { AxiosInstance, AxiosResponse } from "axios";
import { API_ROOT } from "__utils/constants";
import { errorHandler, getAxiosInstance } from "__utils/helpers";
import { FETCH_REQUESTS } from "./constants";

const axios: AxiosInstance = getAxiosInstance(API_ROOT);

export const getRequestsAPI = async (): Promise<AxiosResponse<any>> => {
	return axios.get(FETCH_REQUESTS).catch(errorHandler);
};
